import React, { useEffect, useState, useContext } from "react";
import { SchedulePushNotificationContext } from "@/context/SchedulePushNotificationContext";

const NotificationTextStep = ({ setStepThreeValid }) => {
  //variables for error message handling
  const [truncationError, setTruncatedError] = useState<
    "MIGHTBE" | "WILLBE" | null
  >();
  const [truncationErrorVariables, setTruncationErrorVariables] = useState<{
    textInputClassName: string;
    className: string;
    message: string;
  }>({ textInputClassName: "", className: "", message: "" });

  //state variables
  const { store, setStore } = useContext(SchedulePushNotificationContext);

  //if the text is 0 then set it to invalid
  const onTextChange = (event) => {
    setStore({
      ...store,
      message: event.target.value,
    });
  };

  //validity check and logic for truncation error message handling
  useEffect(() => {
    if (store.message) {
      if (store.message.length > 63 && store.message.length < 120) {
        setTruncatedError("MIGHTBE");
        setTruncationErrorVariables({
          textInputClassName: "may-be-truncated-error",
          className: "may-be-truncated-error-message",
          message: "Message may be shortened on some devices",
        });
      } else if (store.message.length > 119) {
        setTruncatedError("WILLBE");
        setTruncationErrorVariables({
          textInputClassName: "will-be-truncated-error",
          className: "will-be-truncated-error-message",
          message: "Message will be shortened on most devices",
        });
      } else {
        setTruncatedError(null);
        setTruncationErrorVariables({
          textInputClassName: "",
          className: "",
          message: "",
        });
      }
    } else {
      setTruncatedError(null);
      setTruncationErrorVariables({
        textInputClassName: "",
        className: "",
        message: "",
      });
    }

    if (store.message && store.message.length > 0) {
      setStepThreeValid(true);
    } else {
      setStepThreeValid(false);
    }
  }, [store]);

  return (
    <div className={`notification-text-step`}>
      <div className="notification-text-question">
        What would you like the notification to say?
      </div>
      
      <textarea
        aria-label="notification-text-input"
        className={`
          ${truncationErrorVariables.textInputClassName} 
          notification-text narrow-scroll-bar`

        }
        onChange={(e) => onTextChange(e)}
        placeholder={
          "Make your message short and front-load what is important to make sure it's seen."
        }
        maxLength={450}
        value={store.message || ""}
        autoFocus
        rows={5}
      ></textarea>

      
      {truncationError && (
        <div className={truncationErrorVariables.className}>
          {truncationErrorVariables.message}
        </div>
      )}
    </div>
  );
};

export default NotificationTextStep;
